import Request from '../../utils/request'

export const FreeLectureServer = {
    // 免费专区
    getFreeLectureList(params: {type: string}) {
        return Request.$get('/api/index/recommend', {params})
    },
    // 获得免费课列表
    getQrcode(params: {wtype: string, last_url: string}) {
        return Request.$get('/api/board/get_qrcode', {params})
    },
    // 获得荔枝微课公众号二维码
    retainQrcode(params: {stype: string}) {
        return Request.$get('/operating/api/outer/retain/dis_qr_code', {params})
    },
    // 判断当前用户是否是【分流号】的用户
    isSubscribedRetain() {
        return Request.$get('/api/account/is_subscribed_retain', {})
    }
}

export default FreeLectureServer



// WEBPACK FOOTER //
// ./src/services/Modules/freeLectureServer.ts